import { template } from 'lodash';
import axios from './client';

const FLYER_TEMPLATES = '/manage/flyer-templates';
const FLYER_TEMPLATE = template('/manage/flyer-templates/<%= id %>');
const FLYER_TEMPLATE_PREVIEW = template('/manage/flyer-templates/<%= id %>/preview');

const FLYER_CONTRACTOR = template('/contractor/<%= contractorId %>/page/<%= pageId %>/flyer');
const FLYER_CONTRACTOR_IMAGES = template('/contractor/<%= contractorId %>/page/<%= pageId %>/flyer/images');


export function getFlyerTemplates(userTypeId) {
  return axios.get(FLYER_TEMPLATES, { params: { userTypeId } });
}

export function getFlyerTemplate(payload) {
  const id = payload instanceof FormData ? payload.get('id') : payload.id;
  return axios.post(FLYER_TEMPLATE_PREVIEW({ id }), payload, {
    responseType: 'blob',
  });
}

export function getFlyerContractor(contractorId, pageId) {
  return axios.get(FLYER_CONTRACTOR({ contractorId, pageId }), {
    'Content-Type': 'application/x-www-form-urlencoded',
    responseType: 'blob',
  });
}

export function getFlyerContractorImages(contractorId, pageId) {
  return axios.get(FLYER_CONTRACTOR_IMAGES({ contractorId, pageId }), {
    'Content-Type': 'application/x-www-form-urlencoded',
  });
}

export function updateFlyerTemplate(payload) {
  const id = payload instanceof FormData ? payload.get('id') : payload.id;
  return axios.post(FLYER_TEMPLATE({ id }), payload, {
  });
}
